import curry from 'ramda/src/curry';

export const timeout = curry(
    /**
     *
     * @param {number} timeout milliseconds
     * @param {function} fn function
     * @returns
     */
    (timeout, fn) => setTimeout(fn, timeout)
);

export const timeout300 = timeout(300);
